import React, { useEffect, useState, useCallback } from "react";
import ProfileView from "./ProfileView";
import { getProfile, updateProfile } from "../../../api/profileApi";
import { Spinner, ErrorState } from "../../../components/panel/PanelUI";
import {
  getProfileSignature,
  storeProfileSignature,
} from "../../../utils/profileSignature";

// این کامپوننت مسئول فچ کردن دیتاست، نه نمایش آن
export default function ProfileTab() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const loadProfile = useCallback(() => {
    setLoading(true);
    setError("");
    getProfile()
      .then((data) => {
        const signature = getProfileSignature(data);
        if (signature && signature.trim() !== "") {
          storeProfileSignature(signature);
        }
        setProfile(data);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  const handleSave = (formData) => {
    if (!profile?._id) {
      setSaveError("شناسه کاربر برای ویرایش پروفایل پیدا نشد.");
      return;
    }

    setSaving(true);
    setSaveError("");
    updateProfile(profile._id, formData)
      .then((data) => {
        const signature = getProfileSignature(data) || formData.signature;
        storeProfileSignature(signature);
        setProfile(data);
      })
      .catch((err) => setSaveError(err.message))
      .finally(() => setSaving(false));
  };

  if (loading) return <Spinner label="در حال دریافت اطلاعات پروفایل..." />;
  if (error) return <ErrorState message={error} onRetry={loadProfile} />;

  return (
    <ProfileView
      profile={profile}
      onSave={handleSave}
      saving={saving}
      saveError={saveError}
    />
  );
}
